import React, { CSSProperties, ReactElement } from 'react'
import { Dropdown, Icon, IconType } from '@lmc/ui-kit'

type Props = {
  popOver?: ReactElement
  state?: 'signed' | 'unsigned' | 'archived' | 'refused'
}

const ListItemRightChildrenNew = ({ popOver, state }: Props) => {
  if (state === 'archived') {
    return (
      <Icon
        customIcon={IconType.Other}
        style={{ ...styles.otherIcon, ...styles.archived } as CSSProperties}
      />
    )
  }

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Dropdown
        overlay={<div>{popOver}</div>}
        placement="bottomRight"
        trigger={['click']}
      >
        <Icon
          customIcon={IconType.Other}
          style={styles.otherIcon as CSSProperties}
        />
      </Dropdown>
    </div>
  )
}

const styles = {
  archived: {
    cursor: 'default',
  },
  otherIcon: {
    float: 'right',
    cursor: 'pointer',
    marginLeft: 16,
    width: 20,
    height: 20,
  },
}

export default ListItemRightChildrenNew
